import React, { useState } from "react";
import { Card, CardTitle, Row, CardSubtitle, Col } from "reactstrap";
import { UploadDocument, UploadLink } from "../../actions/teacherMutations";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import AddLinkModal from "../Modal/AddLinkModal";
import AddDocumentsModal from "../Modal/AddDocumentModal";
import LicenseExpiredButton from "../Button/LicenseExpiredButton";
import { toast } from "react-toastify";
import { FormattedMessage, useIntl } from "react-intl";
import { formatServiceError } from "../../Utilities/serviceErrorHelper";

export default function DocumentPlaceHolder(props) {
  const intl = useIntl();
  const [linkModalOpen, setLinkModalOpen] = useState(false);
  const [documentModalOpen, setDocumentModalOpen] = useState(false);
  const mutateUploadDocument = useMutation({ mutationFn: UploadDocument });
  const mutateUploadLink = useMutation({ mutationFn: UploadLink });
  const queryClient = useQueryClient();

  const courses = props.coursesData?.data ?? [];
  const noUploadableCourse =
    courses.length > 0 && courses.every((course) => course.licenseExpired);
  const expiredProgramName = courses.find(
    (course) => course.licenseExpired,
  )?.programName;

  const toggleLinkModal = () => {
    setLinkModalOpen((prevState) => !prevState);
  };

  const toggleDocumentModal = () => {
    setDocumentModalOpen((prevState) => !prevState);
  };

  const handleUploadLink = (coursesAndModules, link) => {
    let courseModuleIds = "";
    if (coursesAndModules.modules.length > 0) {
      coursesAndModules.modules.forEach((mod) => {
        courseModuleIds += "&forTheseModules=" + mod;
      });
    }
    let values = {
      link: link,
      classId: props.classId,
      courseId: coursesAndModules.courses,
      teacherId: props.teacherInfo.data.id,
      moduleids: courseModuleIds,
    };
    mutateUploadLink.mutate(
      {
        values,
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({ queryKey: ["FetchCoursesByClassId"] });
          toast.success(intl.formatMessage({ id: "LinkUploaded" }));
        },
        onError: (err) => {
          toast.warn(formatServiceError(intl, err?.response?.data));
        },
      }
    );
  };

  const handleUploadDocument = (coursesAndModules, file) => {
    let courseModuleIds = "";
    if (coursesAndModules.modules.length > 0) {
      coursesAndModules.modules.forEach((mod) => {
        courseModuleIds += "&forTheseModules=" + mod;
      });
    }

    let fileName = file.name.toLowerCase();
    fileName = fileName.replace("ä", "a").replace("å", "a").replace("ö", "o");

    let values = {
      file: file,
      fileName: fileName,
      classId: props.classId,
      courseId: coursesAndModules.courses,
      teacherId: props.teacherInfo.data.id,
      moduleids: courseModuleIds,
    };

    mutateUploadDocument.mutate(
      {
        values,
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({ queryKey: ["FetchCoursesByClassId"] });
          toast.success("Dokumentet har laddats upp");
        },
        onError: (err) => {
          toast.warn(formatServiceError(intl, err?.response?.data));
        },
      }
    );
  };

  return (
    <>
      <Row style={{ justifyContent: "space-evenly" }}>
        <Col lg={6}>
          <Card body>
            <CardTitle>
              <FormattedMessage id="Documents" />
              <hr />
            </CardTitle>
            <CardSubtitle>
              <FormattedMessage id="UploadDocumentText" />
            </CardSubtitle>
            <Row>
              <Col lg={6}>
                <LicenseExpiredButton
                  expired={noUploadableCourse}
                  programName={expiredProgramName}
                  className="mt-2 p-1"
                  onClick={toggleDocumentModal}
                >
                  <FormattedMessage id="UploadDocument" />
                </LicenseExpiredButton>
              </Col>
            </Row>
          </Card>
        </Col>

        <Col lg={6}>
          <Card body>
            <CardTitle>
              <FormattedMessage id="Link" />
              <hr />
            </CardTitle>
            <CardSubtitle>
              <FormattedMessage id="AddLinkText" />
            </CardSubtitle>
            <Row>
              <Col lg={4}>
                <LicenseExpiredButton
                  expired={noUploadableCourse}
                  programName={expiredProgramName}
                  className="mt-2 p-1"
                  onClick={toggleLinkModal}
                >
                  <FormattedMessage id="AddLink" />
                </LicenseExpiredButton>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
      <AddLinkModal
        linkModalOpen={linkModalOpen}
        toggleLinkModal={toggleLinkModal}
        courses={props.coursesData.data}
        handleUploadLink={handleUploadLink}
      />
      <AddDocumentsModal
        documentModalOpen={documentModalOpen}
        toggleDocumentModal={toggleDocumentModal}
        courses={props.coursesData.data}
        handleUploadDocument={handleUploadDocument}
      />
    </>
  );
}
